import $ from 'jquery';

const namespace = 'pagination';

export default class Pagination {
  constructor(options) {
    this.options = $.extend(
      true,
      {
        itemSelector: '.js-pagination-link',
        isControlled: false,
        currentSelector: '.pagination-current',
      },
      options,
    );

    this.bind();
  }

  /**
   * Apply event listeners
   */
  bind() {
    $(document).on(
      `click.${namespace}`,
      this.options.itemSelector,
      this.handleClick.bind(this),
    );
  }

  /**
   * @param {Event} event
   */
  handleClick(event) {
    event.preventDefault();
    const destination = $(event.currentTarget).attr('href');

    if (this.options.isControlled) {
      $(document).trigger(`${namespace}:updated`, {
        uri: destination,
      });

      return;
    }

    window.location = destination;
  }
}
